<template>
    <div class="window-wrapper window-client-check-send dev_confirm_window">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">{{ text }}</div>
                    <div class="button-block">
                        <button @click="confirm" class="button button-dark button-close-window">Да</button>
                        <button @click="closeWindow" class="button button-opacity button-close-window">Отмена</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ConfirmWindow",
    props: ['text'],
    methods: {
        confirm() {
            this.closeWindow();
            this.$emit("confirm");
        },
        closeWindow() {
            $('.window-wrapper').removeClass('window-open');
            $('body').removeClass('blocked');
        }
    }
}
</script>

<style scoped>

</style>